export const RescheduleActionLabelKey = {
  MakePayment: 'reschedule_make_payment_button',
  Confirm: 'reschedule_confirm_button',
  GoForward: 'reschedule_go_forward_button',
} as const;

export type RescheduleActionLabelKey = (typeof RescheduleActionLabelKey)[keyof typeof RescheduleActionLabelKey];

interface Params {
  isLastStep: boolean;
  requiresAdditionalPayment: boolean;
  isChargedRescheduleEnabled: boolean;
}

export function resolveRescheduleActionLabelKey({
  isLastStep,
  requiresAdditionalPayment,
  isChargedRescheduleEnabled,
}: Params): RescheduleActionLabelKey {
  if (isLastStep) {
    return requiresAdditionalPayment && isChargedRescheduleEnabled
      ? RescheduleActionLabelKey.MakePayment
      : RescheduleActionLabelKey.Confirm;
  }

  return RescheduleActionLabelKey.GoForward;
}
